<script setup lang="ts">
const emit = defineEmits<{
  select: []
}>();
const { locale } = useI18n();

const config = useRuntimeConfig();

const overseasLink = computed(() => locale.value === 'fr' ? 'https://www.iadoverseas.com/fr' : 'https://www.iadoverseas.com/');
const propertipsLink = computed(() => locale.value === 'fr' ? 'https://propertips.com/' : 'https://propertips.com/?lang=en_EN');

const allSaleLink = useSerpLinkFromCriteria({
  transactionType: 'sale',
});
const newBuildSaleLink = useSerpLinkFromCriteria({
  transactionType: 'sale',
  projectTypes: ['new'],
});
const businessLink = useSerpLinkFromCriteria({
  transactionType: 'sale',
  propertyTypes: ['business'],
});
const houseLink = useSerpLinkFromCriteria({
  transactionType: 'sale',
  propertyTypes: ['house'],
});
const apartmentLink = useSerpLinkFromCriteria({
  transactionType: 'sale',
  propertyTypes: ['apartment'],
});
const landLink = useSerpLinkFromCriteria({
  transactionType: 'sale',
  propertyTypes: ['land'],
});
const parkingLink = useSerpLinkFromCriteria({
  transactionType: 'sale',
  propertyTypes: ['parking'],
});
const buildingLink = useSerpLinkFromCriteria({
  transactionType: 'sale',
  propertyTypes: ['building'],
});

function onClick() {
  emit('select');
}
</script>

<template>
  <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-s">
    <div class="col-span-2 border-b lg:border-b-0 lg:border-r border-black/10">
      <div class="flex flex-col gap-l">
        <span
          class="lg:hidden text-lg font-semibold group-[.is-prestige]:text-xl group-[.is-prestige]:font-normal group-[.is-prestige]:uppercase"
          v-text="$t('core.navigation.buy')"
        />
        <span
          class="text-lg font-normal"
          v-text="$t('core.header.your_research')"
        />
      </div>
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-xl lg:gap-2xl pl-m lg:pr-xl mt-m pb-l lg:pb-0">
        <div class="flex flex-col gap-xl">
          <MainHeaderMenuItemLink
            variant="submenu"
            :text="$t('core.header.menu.all_properties_for_sale')"
            :to="allSaleLink"
            menu-category1="buy"
            @click="onClick"
          />
          <MainHeaderMenuItemLink
            variant="submenu"
            :text="$t('core.header.menu.new_build')"
            :to="newBuildSaleLink"
            menu-category1="buy"
            menu-category2="new"
            @click="onClick"
          />
          <MainHeaderMenuItemLink
            v-if="config.public.enablePrestige"
            variant="submenu"
            :text="$t('property.tags.prestige')"
            :to="{
              name: 'prestige',
            }"
            menu-category1="buy"
            menu-category2="prestige"
            @click="onClick"
          />
          <MainHeaderMenuItemLink
            variant="submenu"
            :text="$t('core.header.menu.overseas')"
            :href="overseasLink"
            target="_blank"
            menu-category1="buy"
            menu-category2="international"
            @click="onClick"
          />
          <MainHeaderMenuItemLink
            variant="submenu"
            :text="$t('core.header.menu.commercial')"
            :to="businessLink"
            menu-category1="buy"
            menu-category2="business"
            @click="onClick"
          />
          <MainHeaderMenuItemLink
            variant="submenu"
            :text="$t('property.types_and_sub_types.house')"
            :to="houseLink"
            menu-category1="buy"
            menu-category2="house"
            @click="onClick"
          />
        </div>
        <div class="flex flex-col gap-xl">
          <MainHeaderMenuItemLink
            variant="submenu"
            :text="$t('property.types_and_sub_types.apartment')"
            :to="apartmentLink"
            menu-category1="buy"
            menu-category2="apartment"
            @click="onClick"
          />
          <MainHeaderMenuItemLink
            variant="submenu"
            :text="$t('property.types_and_sub_types.land')"
            :to="landLink"
            menu-category1="buy"
            menu-category2="land"
            @click="onClick"
          />
          <MainHeaderMenuItemLink
            variant="submenu"
            :text="$t('property.types_and_sub_types.parking')"
            :to="parkingLink"
            menu-category1="buy"
            menu-category2="parking"
            @click="onClick"
          />
          <MainHeaderMenuItemLink
            variant="submenu"
            :text="$t('property.types_and_sub_types.building')"
            :to="buildingLink"
            menu-category1="buy"
            menu-category2="building"
            @click="onClick"
          />
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-m pt-l lg:pt-0">
      <span
        class="text-lg font-normal"
        v-text="$t('core.header.supporting_project')"
      />
      <div class="flex flex-col gap-xl pl-m">
        <MainHeaderMenuItemLink
          v-if="locale === 'fr'"
          variant="submenu"
          :text="$t('core.header.menu.purchasing_advice')"
          href="https://blog.iadfrance.fr/conseil-immobilier/achat/"
          target="_blank"
          menu-category1="buy"
          menu-category2="buying_advices"
          @click="onClick"
        />
        <MainHeaderMenuItemLink
          v-if="locale === 'fr'"
          variant="submenu"
          :text="$t('core.header.menu.real_estate_trends')"
          href="https://blog.iadfrance.fr/tag/barometre-lpi-iad/"
          target="_blank"
          menu-category1="buy"
          menu-category2="housing_market"
          @click="onClick"
        />
        <MainHeaderMenuItemLink
          variant="submenu"
          :text="$t('core.header.menu.recommend_buyer')"
          :href="propertipsLink"
          target="_blank"
          menu-category1="buy"
          menu-category2="help_a_relative"
          @click="onClick"
        />
      </div>
    </div>
  </div>
</template>
